import React from "react";
import styled from "styled-components";

export default function Rules() {
    return <RulesWrapper>
        <Title>Membership Rules</Title>
        <Desc>
            1.Membership can only be acquired by purchasing COCOS. You can only buy once with a single address.<br/>
            2.There is a limited membership quota. The price will rise automatically by 2 COCOS each time 100 memberships are sold.<br/>
            3.You cannot transfer your membership to others.<br/>
            4.Only members are eligible for COCOS Mystery Box NFT purchase, IGO and launchpads.<br/>
            5.Only 5,000 memberships will be released in the initial period.<br/>
            6.COCOS will not be deducted from whitelist users when they make the purchase.<br/>
            7.You must enter a username before purchasing.
        </Desc>
    </RulesWrapper>
}

const RulesWrapper = styled.div`
  width: 1150px;
  height: 286px;
  background: #11388C;
  border-radius: 20px;
  padding: 36px 45px;
  margin-top: 30px;
`
const Title = styled.h3`
  font-size: 28px;
  color: #93B5FF;
  line-height: 34px;
`

const Desc = styled.p`
  font-size: 14px;
  color: #6090F8; 
  line-height: 24px;
  margin-top: 14px;
`